import React from 'react';

const GoogleDocsExportModal = ({ isOpen, onClose, documentUrl, title }) => {
  if (!isOpen) return null;

  const handleOpenDocument = () => {
    window.open(documentUrl, '_blank');
    onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="rounded-lg shadow-xl p-6 w-[500px] max-w-[90vw]" style={{background: 'var(--tqa-surface)', border: '1px solid var(--tqa-border-dark)'}}>
        {/* Success Icon */}
        <div className="flex items-center justify-center mb-4">
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center">
            <svg 
              className="w-8 h-8 text-green-600" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M5 13l4 4L19 7" 
              />
            </svg>
          </div>
        </div>

        {/* Title */}
        <h3 className="text-xl font-semibold mb-2 text-center" style={{color: 'rgba(255,255,255,0.85)'}}>
          Successfully Exported!
        </h3>

        {/* Message */}
        <p className="text-center mb-4" style={{color: 'rgba(255,255,255,0.5)'}}>
          Your document has been exported to Google Docs
        </p>

        {/* Document Info */}
        <div className="rounded-lg p-4 mb-6" style={{background: 'rgba(130,255,207,0.08)', border: '1px solid rgba(130,255,207,0.2)'}}>
          <div className="flex items-start">
            <svg 
              className="w-6 h-6 mr-3 mt-0.5 flex-shrink-0" 
              style={{color: 'var(--tqa-green)'}}
              fill="currentColor" 
              viewBox="0 0 20 20"
            >
              <path 
                fillRule="evenodd" 
                d="M4 4a2 2 0 012-2h4.586A2 2 0 0112 2.586L15.414 6A2 2 0 0116 7.414V16a2 2 0 01-2 2H6a2 2 0 01-2-2V4zm2 6a1 1 0 011-1h6a1 1 0 110 2H7a1 1 0 01-1-1zm1 3a1 1 0 100 2h6a1 1 0 100-2H7z" 
                clipRule="evenodd" 
              />
            </svg>
            <div className="flex-1 min-w-0">
              <p className="text-sm font-medium mb-1" style={{color: 'rgba(255,255,255,0.85)'}}>Document Name</p>
              <p className="text-sm break-words" style={{color: 'rgba(255,255,255,0.65)'}}>{title}</p>
            </div>
          </div>
        </div>

        {/* Action Buttons */}
        <div className="flex space-x-3">
          <button
            type="button"
            onClick={onClose}
            className="btn-secondary flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors"
          >
            Close
          </button>
          <button
            type="button"
            onClick={handleOpenDocument}
            className="btn-primary flex-1 px-4 py-2.5 text-sm font-medium rounded-lg transition-colors flex items-center justify-center"
          >
            <svg 
              className="w-4 h-4 mr-2" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
              />
            </svg>
            Open in Google Docs
          </button>
        </div>
      </div>
    </div>
  );
};

export default GoogleDocsExportModal;
